import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

export function Kbd({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <kbd
      className={cn(
        'inline-flex h-[18px] min-w-[18px] items-center justify-center rounded border border-line bg-board px-1 font-sans text-[10px] text-ink-faint shadow-sm',
        className,
      )}
      {...props}
    />
  );
}
